<template>
  <div
    class="page_container addEditBrandIncreasePage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/AdvertismentIndex/aManageIndex' }"
          >广告管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{activeLabel}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>{{activeLabel}}</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>名称：</p>
            <div class="input_box">
              <el-input v-model="formData.topic" placeholder="名称"></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>图片</p>
            <div
              class="upload_box"
              @mouseenter="enter(1)"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.pic" @mouseleave="creenIndex = ''">
                  <img :src="formData.pic" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span @click.stop="handlePictureCardPreview(formData.pic, 1)"
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(1)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="block" v-if="false">
            <p><span class="mark">*</span>加载页：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.sitein"
                style="justify-content: space-evenly"
              >
                <el-radio :label="1" disabled>首页</el-radio>
                <el-radio :label="2" disabled>加载页</el-radio>
                <el-radio :label="3" disabled>商品列表页banner</el-radio>
                <el-radio :label="4" disabled>eventbanner</el-radio>
                <el-radio :label="5" disabled>活动列表页顶部小banner</el-radio>
                <el-radio :label="6" disabled>A型聚合页内容</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p>排序：</p>
            <div class="input_box">
              <el-input v-model="formData.sortno" placeholder="排序"></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>跳转类型：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.gotype"
                style="justify-content: space-evenly"
              >
                <el-radio label="3">不跳转</el-radio>
                <el-radio label="1">HTTP(HTTPS)链接</el-radio>
                <el-radio label="4">本体小程序内部路径path</el-radio>
                <el-radio label="2">第三方小程序</el-radio>
                <el-radio label="5">打开图片</el-radio>
                <el-radio label="6">自有商品</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 1">
            <p><span class="mark">*</span>链接：</p>
            <div class="input_box">
              <el-input
                v-model="formData.HttpsUrl"
                placeholder="链接"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 4">
            <p><span class="mark">*</span>内部路径：</p>
            <div class="input_box">
              <el-input
                v-model="formData.InUrl"
                placeholder="内部路径"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 2">
            <p><span class="mark">*</span>第三方小程序AppID：</p>
            <div class="input_box">
              <el-input
                v-model="formData.otherappid"
                placeholder="第三方小程序AppID"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 2">
            <p><span class="mark">*</span>第三方小程序原始ID：</p>
            <div class="input_box">
              <el-input
                v-model="formData.otherappid_ori"
                placeholder="第三方小程序原始ID"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 2">
            <p><span class="mark">*</span>小程序路径：</p>
            <div class="input_box">
              <el-input
                v-model="formData.otherapppath"
                placeholder="小程序路径"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 2">
            <p>备用Url：</p>
            <div class="input_box">
              <el-input
                v-model="formData.otherappurl"
                placeholder="备用Url"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 5">
            <p><span class="mark">*</span>打开图片</p>
            <div
              class="upload_box"
              @mouseenter="enter(2)"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.picurl" @mouseleave="creenIndex = ''">
                  <img :src="formData.picurl" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 2"
                  >
                    <span
                      @click.stop="handlePictureCardPreview(formData.picurl, 2)"
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(2)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 6">
            <div class="select_shop_wrap">
              <div class="name">商品名称：{{ selectShop.commodityname }}</div>
              <div class="add_btn flex-rowc" @click="handleShowShop">选择商品</div>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>状态：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.astate"
                style="justify-content: space-evenly"
              >
                <el-radio label="启用">启用</el-radio>
                <el-radio label="停用">停用</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

     <!-- 商品列表弹窗 start -->
     <div class="custom_dialog" v-show="isShowShop">
      <div class="custom_wrap">
        <div class="diaog_head">
          <div class="search_wrap flex-rowl">
            <div class="search_box flex-between">
              <el-input
                v-model="shopForm.keyword"
                placeholder="查找商品"
                @keyup.enter.native="handleSearch"
              ></el-input>
              <div class="search_btn flex-rowc" @click="handleSearch">
                <i class="iconfont icon-chazhaotubiao"></i>
              </div>
            </div>
            <div class="rest flex-rowc" @click="handleRest">
              重置搜索结果
              <i class="iconfont icon-shuaxin"></i>
            </div>
          </div>

          <div class="close_icon" @click="isShowShop = false">
            <i class="iconfont icon-guanbi"></i>
          </div>
        </div>
        <div
          class="diaog_body"
          v-loading="isLoading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          ref="container"
          @scroll="handleScroll"
        >
          <div class="shop_wrap">
            <div
              class="shop_item flex-rowl"
              v-for="item in shopList"
              :key="item.id"
              @click="handleSelectShop(item)"
            >
              <!-- <div class="radio" :class="{ active: item.id == selectShop.id }">
                <span class="iconfont icon-danxuanyixuan"></span>
              </div> -->
              <div class="shop_cont flex-rowl">
                <div class="shop_img">
                  <el-image
                    style="width: 80px; height: 80px"
                    fit="cover"
                    :src="item.img"
                  ></el-image>
                </div>
                <div class="shop_txt">
                  <h1>{{ item.commodityname }}</h1>
                </div>
              </div>
            </div>
          </div>
          <el-empty
            description="暂无商品"
            v-if="shopList.length == 0 && !isLoading"
          ></el-empty>
        </div>
        <div class="dialog_footer flex-rowl">
          <!-- <div class="btn" @click="handleQueryShop">确认</div> -->
          <div class="return_txt" @click="isShowShop = false">←返回</div>
        </div>
      </div>
    </div>
    <!-- 商品列表弹窗 end -->
  </div>
</template>

<script>
import {
  getAdverBannerDetail,
  // uploadImage,
  addAdverBanner,
  editAdverBanner,
  encryptstringview,
  getCommondity
} from "../../api/api";
import { getImageToken, uploadImageOss } from "../../utils/oss";
import { mapState } from "vuex";
export default {
  name: "adverBnnaer",
  data() {
    return {
      qyid: 0,
      id: "",

      loading: false,
      formData: {
        id: '',
        qyguid: "",
        topic: "",
        pic: "",
        sitein: "",
        sortno: "",
        gotype: 1,
        HttpsUrl: "",
        InUrl: "",
        otherappid: "",
        otherappid_ori: "",
        otherapppath: "",
        otherappurl: "",
        picurl: "",
        astate: "停用",
        cmid: ''
      },
      activeLabel: '',
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,

      // 商品
      isShowShop: false,
      shopForm: {
        Page: 1,
        PageSize: 10,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 1, // 1 上架 0 下架 2 全部 留空为上架
        qyid: this.$store.state.USERINFO.qy
          ? this.$store.state.USERINFO.qy.id
          : 0,
      },
      isLoading: true,
      shopList: [],
      shopTotal: 0, // 商品总数量
      selectShop: {
        id: '',
        commodityname: ''
      },  // 选择商品
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.qyguid = USERINFO.qy.qyguid;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, sitein, activeLabel } = JSON.parse(res.jsondata);
        this.activeLabel = activeLabel
        this.formData.sitein = sitein;
        if (id) {
          this.formData.id = id;
          this.init(id);
        }
      } else {
        this.$router.back();
      }
    },

    init(id) {
      this.loading = true;
      getAdverBannerDetail({ id }).then((res) => {
        this.formData.topic = res.topic;
        this.formData.pic = res.pic ? res.pic : "";
        // this.formData.sitein = res.sitein ? res.sitein : "";
        this.formData.sortno = res.sortno;
        this.formData.gotype = res.gotype ? res.gotype : "";
        this.formData.cmid = res.cmid ? res.cmid : "";
        this.selectShop.id = res.cmid ? res.cmid : "";
        this.selectShop.commodityname = res.commodityname ? res.commodityname : "";
        this.formData.HttpsUrl = res.HttpsUrl;
        this.formData.InUrl = res.InUrl;
        this.formData.otherappid = res.otherappid;
        this.formData.otherappid_ori = res.otherappid_ori;
        this.formData.otherapppath = res.otherapppath;
        this.formData.otherappurl = res.otherappurl;
        this.formData.picurl = res.picurl;
        this.formData.astate = res.astate ? res.astate : "停用";
        this.loading = false;
      });
    },

    handleShowShop() {
      this.shopForm.Page = 1;
      this.shopList = [];
      this.isShowShop = true
      this.loadMore()
    },
    // 搜索商品
    handleSearch() {
      this.shopForm.Page = 1;
      this.shopList = [];
      this.loadMore();
    },
    // 重置搜索结果
    handleRest() {
      this.shopForm.Page = 1;
      this.shopForm.keyword = "";
      this.shopList = [];
      this.loadMore();
    },
    async loadMore() {
      this.isLoading = true;
      try {
        const res = await getCommondity(this.shopForm);
        if (res.list.length > 0) {
          this.shopList = [...this.shopList, ...res.list];
          this.shopTotal = res.total;
          this.shopForm.Page += 1;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleScroll() {
      let {shopList, shopTotal} = this
      const container = this.$refs.container;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight && shopList.length < shopTotal
      ) {
        this.loadMore();
      }
    },
    
    // 选择商品
    handleSelectShop(item) {
      this.isShowShop = false
      this.formData.cmid = item.id
      this.selectShop = item
    },

    handleReturn() {
       this.$router.push({ name: "aManageIndex" });
    },

    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },

    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },
    // 移出图片
    handleRemove(isType) {
      if (isType == 1) {
        this.formData.pic = "";
      } else if (isType == 2) {
        this.formData.picurl = "";
      }
      this.creenIndex = ''
    },

    async beforeAvatarUpload(e) {
      let { file } = e;
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
        return;
      }

      let { creenIndex } = this;
      this.loading = true;
      try {
        let { data } = await getImageToken(file.name);

        let { status } = await uploadImageOss(data, file);
        if (status == 200) {
          let url = data.host + "/" + data.key;
          if (creenIndex == 1) {
            this.formData.pic = url;
          } else if (creenIndex == 2) {
            this.formData.picurl = url;
          }
        }
        this.creenIndex = ''
        this.loading = false;
      } catch (error) {
        this.loading = false;
        // console.error("Upload failed:", error);
      }
    },

    query() {
      let { formData } = this;
      if (formData.topic == "") {
        this.$message.warning("请输入名称");
        return;
      }
      if (formData.pic == "") {
        this.$message.warning("请上传图片");
        return;
      }
      if (formData.sitein == "") {
        this.$message.warning("请选择加载页");
        return;
      }
      if (formData.sortno == "") {
        this.$message.warning("请输入排序");
        return;
      }
      if (formData.gotype == "") {
        this.$message.warning("请选择跳转类型");
        return;
      }
      if (formData.gotype == 1 && formData.HttpsUrl == "") {
        this.$message.warning("请输入链接");
        return;
      }
      if (formData.gotype == 4 && formData.InUrl == 4) {
        this.$message.warning("请输入内部路径");
        return;
      }
      if (formData.gotype == 2) {
        if (formData.otherappid == "") {
          this.$message.warning("请输入第三方小程序AppID");
          return;
        }
        // if (formData.otherappid_ori == "") {
        //   this.$message.warning("请输入第三方小程序原始ID");
        //   return;
        // }
        if (formData.otherapppath == "") {
          this.$message.warning("请输入小程序路径");
          return;
        }
        // if (formData.otherappurl == "") {
        //   this.$message.warning("请输入备用Url");
        //   return;
        // }
      }
      if (formData.gotype == 5 && formData.picurl == "") {
        this.$message.warning("请上传打开图片");
        return;
      }
      if (formData.gotype == 6 && formData.cmid == "") {
        this.$message.warning("请选择商品");
        return;
      }
      if (formData.id == "") {
        this.loading = true;
        addAdverBanner(formData).then((res) => {
          if (res.result) {
            // this.$toast.success(res.message);
            // setTimeout(() => {
            //   // this.clearData();
            //   history.back();
            // }, 1500);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            // this.clearData();
            this.$message.error(res.message);
          }
        });
      } else {
        this.loading = true;
        editAdverBanner(formData).then((res) => {
          if (res.result) {
            this.$message.success(res.message);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    clearData() {
      this.formData.labelname = "";
      this.formData.radio = "";
      this.formData.linkurl = "";
      this.formData.apppath = "";
      this.formData.labelstate = "";
      this.formData.labelcont_y = "";
      this.formData.labelcont_m = "";
      this.formData.labelcont_t = "";
      this.formData.logo = "";
      this.formData.sort = "";
    },
  },
};
</script>
<style lang="less" scoped>
.addEditBrandIncreasePage {
  .select_shop_wrap {
    .name {
      font-size: 14px;
      margin-bottom: 20px;
    }
    .add_btn {
      height: 45px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
  .custom_dialog {
    .search_wrap {
      .search_box {
        flex-shrink: 0;
        width: 60%;
      }
      .rest {
        font-size: 14px;
        color: #444;
        height: 35px;
        border-radius: 18px;
        border: 1px solid #d8d8d8;
        padding: 0 14px 0 28px;
        margin-left: 19px;
        cursor: pointer;
        .iconfont {
          margin-left: 10px;
        }
      }
    }
    .shop_wrap {
      .shop_item {
        cursor: pointer;
        margin-bottom: 15px;
        .radio {
          margin-right: 10px;
          color: #c8c8c8;
          &.active {
            color: #515151;
          }
        }
        .shop_cont {
          // align-items: flex-start;
          h1 {
            font-size: 14px;
            margin-left: 10px;
          }
        }
      }
    }
    .address_list {
      .address_item {
        font-size: 14px;
        border: 1px solid #dcdcdc;
        color: #6e6e6e;
        padding: 10px 10px;
        margin-bottom: 20px;
        cursor: pointer;
        .radio {
          margin-right: 14px;
          .iconfont {
            font-size: 22px;
            color: #a5a5a5;
            &.icon-danxuanyixuan1 {
              color: #f62560;
            }
          }
        }
        p {
          height: 22px;
          line-height: 22px;
        }
      }
    }
    &.custom_dialog_address {
      .diaog_head {
        height: 60px;
      }
      .close_icon {
        position: absolute;
        right: 25px;
        top: 25px;
        cursor: pointer;
        z-index: 999;
        .iconfont {
          font-size: 22px;
        }
      }
      .diaog_body {
        height: 50vh;
        .diaog_wrap {
          height: 42vh;
          overflow-y: scroll;
          .form_wrap {
            .block {
              margin-bottom: 20px;
              p {
                font-size: 14px;
                color: #6e6e6e;
                margin-bottom: 8px;
                .mark {
                  font-size: 12px;
                  color: #ff0012;
                  margin-right: 4px;
                }
              }
              .input_box,
              .select_box {
                width: 90%;
              }
            }
          }
        }
      }
    }
    &.customer_list_dialog {
      background: none;
      .dialog_head {
        height: 60px;
        padding: 0 20px 0;
        box-sizing: border-box;
        position: relative;
        h1 {
          font-size: 18px;
        }
        .close_icon {
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .diaog_body {
        margin-top: 0;
        height: 46vh;
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #fe3c46;
        }
      }
      .return_txt {
        cursor: pointer;
      }
    }
  }
}
</style>